import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * The first row of a job section. The masthead above already names the job and the active tab names the section,
 * so the title is for screen readers only; what shows is one quiet sentence of context on the left and the
 * section's actions on the right. Keeps every job page starting the same way.
 */
export function PageIntro({ title, description, actions, children, className }: { title: string; description?: ReactNode; actions?: ReactNode; children?: ReactNode; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-3 md:flex-row md:items-start md:justify-between md:gap-6', className)}>
      <div className="min-w-0 max-w-2xl">
        <h2 className="sr-only">{title}</h2>
        {description && <p className="text-muted-foreground text-sm leading-relaxed">{description}</p>}
        {children}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
